import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ApiService } from 'src/services/api.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { goToLoginIfNotLoggedIn } from '../../services/ObservableExtension';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  user: any;
  isValveOpen: boolean = true;

  modal: NgbModalRef;
  @ViewChild('notificationModal')
  notificationModal: ElementRef;
  hasNotifications = false;
  notifications: any = [];
  userNotifications: any = [];
  chkNotificationShowAgain: boolean;
  showReadNotificationPageLoad: boolean;

  constructor(
    public api: ApiService,
    private ngbModal: NgbModal,
    private router: Router,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.user = {
      FirstName: this.api.userFirstName,
      LastName: this.api.userLastName,
      IsPlatformAdmin: this.api.isPlatformAdmin
    };

    this.checkValveStatus();
    this.getNotifications();
  }

  checkValveStatus() {
    this.api.get("customer/valveStatus").subscribe((status: any) => {
      this.isValveOpen = status;
    });
  }

  getNotifications() {
    this.api.get("notifications?raisedOnly=false&count=20").pipe(goToLoginIfNotLoggedIn(this.router)).subscribe((response: any) => {
      this.notifications = response;
      if (this.notifications && this.notifications.length) {
        this.hasNotifications = true;
      }
      this.showReadNotificationPageLoad = true;
      this.getUserNotifications(false);
    });
  }

  getUserNotifications(isRead: boolean = null) {
    this.api.get("userNotifications?oldNotifications=" + isRead + "").pipe(goToLoginIfNotLoggedIn(this.router)).subscribe((response: any) => {
      this.userNotifications = response;
      if (this.userNotifications && this.userNotifications.length) {
        this.hasNotifications = true;
      }
      if (this.hasNotifications) {
        this.modal = this.ngbModal.open(this.notificationModal, { size: 'lg', scrollable: true, backdrop: 'static' });
      }
    });
  }

  logout() {
    this.api.logout().subscribe(() => {
      this.router.navigateByUrl('/login');
    });
  }

  onClickOpenNotification() {
    this.showReadNotificationPageLoad = false;
    this.getUserNotifications();
    // this.modal = this.ngbModal.open(this.notificationModal, { size: 'lg', scrollable: true, backdrop: 'static' });
  }

  updateNotifications() {
    //to check if popup is open on page load or via on click of notification bell
    if (this.showReadNotificationPageLoad) {
      var data = {
        NeverShowChecked: true
      }
      this.api.put('readnotifications/', data)
        .subscribe((response: any) => {
          this.modal.close();
        }, (error: any) => {
          this.modal.close();
        });
    } else {
      this.modal.close();
    }
  }

  closeNotificationModel() {
    this.updateNotifications();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.updateNotifications();
  }

}
